import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { castelist, religionlist, subcastelist } from "../../../services/master";
import { grouplist, membercreate, memberdetail, memberlistloan } from "../../../services/admin";
import { getrestrictions } from "../../../services/setting";
import { toast } from "react-toastify";
import ImageUrl from "../../../ImageUrl";
import Select from "react-select";
import {
  verifyPan as kycVerifyPan,
  aadhaarSendOtp as kycAadhaarSendOtp,
  aadhaarVerifyOtp as kycAadhaarVerifyOtp,
  verifyBank as kycVerifyBank,
} from "../../../services/kyc";

// Whole-year age from a date of birth. Accepts the free-text dd/mm/yyyy this
// form uses (and falls back to native parsing for other formats). Empty for a
// missing/incomplete/future date, so the Age field clears with the DOB.
const ageFromDob = (dob) => {
  if (!dob) return "";
  const s = String(dob).trim();
  let b;
  const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmy) {
    b = new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
  } else {
    b = new Date(s);
  }
  if (isNaN(b.getTime())) return "";
  const now = new Date();
  let age = now.getFullYear() - b.getFullYear();
  const m = now.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < b.getDate())) age--;
  return age >= 0 && age < 150 ? String(age) : "";
};

export default function Addmember() {
  const navigate = useNavigate();
  const { id, gid } = useParams();
  const [urllink, setUrllink] = useState("");
  const [uname, setUName] = useState("");
  const [pass, setPass] = useState("");
  const [mname, setMName] = useState("");
  const [mdob, setMDob] = useState("");
  const [mage, setMAge] = useState("");
  const [sgender, setSGender] = useState("");
  const [marital, setMarital] = useState("");
  const [hname, setHName] = useState("");
  const [hdob, setHDob] = useState("");
  const [hage, setHAge] = useState("");
  const [phone, setPhone] = useState("");
  const [aphone, setAPhone] = useState("");

  const [aadno, setAadno] = useState("");

  // KYC (Cashfree) verification state
  const [pan, setPan] = useState("");
  const [panVerified, setPanVerified] = useState(false);
  const [panLoading, setPanLoading] = useState(false);
  // Verify buttons enabled in Settings. The Aadhaar/PAN/bank fields are member
  // data and stay visible either way; only the verify buttons are gated.
  const [kycAllowed, setKycAllowed] = useState({
    aadhaar: true,
    pan: true,
    bank: true,
  });
  const [aadhaarVerified, setAadhaarVerified] = useState(false);
  const [aadhaarRefId, setAadhaarRefId] = useState("");
  const [aadhaarOtp, setAadhaarOtp] = useState("");
  const [aadhaarOtpSent, setAadhaarOtpSent] = useState(false);
  const [aadhaarLoading, setAadhaarLoading] = useState(false);
  const [bankAcc, setBankAcc] = useState("");
  const [bankIfsc, setBankIfsc] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankVerified, setBankVerified] = useState(false);
  const [bankLoading, setBankLoading] = useState(false);

  const [mplace, setMPlace] = useState("");
  const [pfile, setPFile] = useState("");
  const [purl, setPUrl] = useState("");

  const [srel, setSRel] = useState("");
  const [rlist, setRList] = useState([]);

  const [scaste, setSCaste] = useState("");
  const [sclist, setSCList] = useState([]);
  const [subcas, setSubCas] = useState("");
  const [sublist, setSubList] = useState([]);

  const [mdetail, setMDetail] = useState("");
  const [hdetail, setHDetail] = useState("");
  const [paddr, setPAddr] = useState("");
  const [taddr, setTAddr] = useState("");
  const [occu, setOccu] = useState("");
  const [idaily, setIDaily] = useState("");
  const [imonth, setIMonth] = useState("");
  const [iwdays, setIWDays] = useState("");
  const [anninc, setAnnInc] = useState("");

  const [lincome, setLIncome] = useState("");
  const [pincome, setPIncome] = useState("");
  const [oincome, setOIncome] = useState("");
  const [ototal, setOTotal] = useState("");

  // Asset details are optional and default to "No".
  const [ohouse, setOHouse] = useState("No");
  const [rhouse, setRHouse] = useState("No");
  const [lhouse, setLHouse] = useState("No");
  const [oassets, setOAssets] = useState("No");

  const [mgroup, setMGroup] = useState("");
  // True when the member being edited has a loan currently in progress; the
  // Group cannot be changed while that is the case.
  const [hasActiveLoan, setHasActiveLoan] = useState(false);
  // Group loans off => individual-only, so the group-detail section is hidden.
  const [groupLoansAllowed, setGroupLoansAllowed] = useState(true);
  const [glist, setGList] = useState([]);
  const [efee, setEFee] = useState("");


  let arr = [];

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }
  const location = useLocation();

  useEffect(() => {
    getrestrictions().then((res) => {
      if (res?.status === true) {
        setGroupLoansAllowed(!!res.data?.details?.allow_group_loans);
        if (res.data?.allowed_kyc_channels) {
          setKycAllowed(res.data.allowed_kyc_channels);
        }
      }
    });
  }, []);

  useEffect(() => {

    const path = location.pathname.split("/")[2];
    setUrllink(path);

    if (path === "memberdetail" || path === "groupmemberdetail") {
      // A member with a loan in progress must not be moved to another group, so
      // check their live loans and lock the Group field when any exist.
      setHasActiveLoan(false);
      memberlistloan(id).then((res) => {
        const loans = res?.status === true ? (res.data?.details || []) : [];
        setHasActiveLoan(loans.length > 0);
      });
      memberdetail(id).then((res) => {
        if (res.status === true) {
          if (res.data.details !== null) {
            setUName(res.data.details.username ?? "");
            setPass(res.data.details.password ?? "");
            if (res.data.details.member_name !== null) {
              setMName(res.data.details.member_name);
            }
            if (res.data.details.member_dob !== null) {
              setMDob(res.data.details.member_dob);
            }
            if (res.data.details.member_age !== null) {
              setMAge(res.data.details.member_age);
            }
            if (res.data.details.gender !== null) {
              setSGender(res.data.details.gender);
            }
            if (res.data.details.marital_status !== null) {
              setMarital(res.data.details.marital_status);
            }
            if (res.data.details.husband_name !== null) {
              setHName(res.data.details.husband_name);
            }
            if (res.data.details.husband_dob !== null) {
              setHDob(res.data.details.husband_dob);
            }
            if (res.data.details.husband_age !== null) {
              setHAge(res.data.details.husband_age);
            }
            if (res.data.details.phone_no !== null) {
              setPhone(res.data.details.phone_no);
            }
            if (res.data.details.alternate_no !== null) {
              setAPhone(res.data.details.alternate_no);
            }
            if (res.data.details.aadhar_no !== null) {
              setAadno(res.data.details.aadhar_no);
            }
            if (res.data.details.pan_no) setPan(res.data.details.pan_no);
            if (res.data.details.bank_account_no) setBankAcc(res.data.details.bank_account_no);
            if (res.data.details.bank_ifsc) setBankIfsc(res.data.details.bank_ifsc);
            if (res.data.details.bank_name) setBankName(res.data.details.bank_name);
            setPanVerified(Number(res.data.details.pan_verified) === 1);
            setAadhaarVerified(Number(res.data.details.aadhaar_verified) === 1);
            setBankVerified(Number(res.data.details.bank_verified) === 1);
            if (res.data.details.native_place !== null) {
              setMPlace(res.data.details.native_place);
            }
            if (res.data.details.religion_id !== null) {
              setSRel(res.data.details.religion_id);
            }
            if (res.data.details.caste_id !== null) {
              setSCaste(res.data.details.caste_id);
            }
            if (res.data.details.subcaste_id !== null) {
              setSubCas(res.data.details.subcaste_id);
            }
            if (res.data.details.member_detail !== null) {
              setMDetail(res.data.details.member_detail);
            }
            if (res.data.details.husband_detail !== null) {
              setHDetail(res.data.details.husband_detail);
            }
            if (res.data.details.permanent_address !== null) {
              setPAddr(res.data.details.permanent_address);
            }
            if (res.data.details.temporary_address !== null) {
              setTAddr(res.data.details.temporary_address);
            }
            if (res.data.details.occupation !== null) {
              setOccu(res.data.details.occupation);
            }
            if (res.data.details.daily_income !== null) {
              setIDaily(res.data.details.daily_income);
            }
            if (res.data.details.monthly_income !== null) {
              setIMonth(res.data.details.monthly_income);
            }
            if (res.data.details.working_days !== null) {
              setIWDays(res.data.details.working_days);
            }
            if (res.data.details.annual_income !== null) {
              setAnnInc(res.data.details.annual_income);
            }
            if (res.data.details.nancei_income !== null) {
              setLIncome(res.data.details.nancei_income);
            }
            if (res.data.details.puncei_income !== null) {
              setPIncome(res.data.details.puncei_income);
            }
            if (res.data.details.other_income !== null) {
              setOIncome(res.data.details.other_income);
            }
            if (res.data.details.overall_total !== null) {
              setOTotal(res.data.details.overall_total);
            }
            if (res.data.details.own_house !== null) {
              setOHouse(res.data.details.own_house);
            }
            if (res.data.details.rent_house !== null) {
              setRHouse(res.data.details.rent_house);
            }
            if (res.data.details.lease_house !== null) {
              setLHouse(res.data.details.lease_house);
            }
            if (res.data.details.other_assets !== null) {
              setOAssets(res.data.details.other_assets);
            }
            if (res.data.details.group_id !== null) {
              // setMGroup(res.data.details.group_id);
              const temp = new FormData();
              temp.append("branch", localStorage.getItem("branch"));
              grouplist(temp).then((res1) => {
                if (res1.status === true) {
                  let arr = [];
                  if (res1.data.length > 0) {
                    for (let i = 0; i < res1.data.length; i++) {
                      if (res1.data[i].id == res.data.details.group_id) {
                        arr.push({
                          value: res1.data[i].id,
                          label: res1.data[i].group_name
                        })
                      }
                    }
                    setMGroup(arr[0]);
                  }
                }
              })
            }
            if (res.data.details.entry_fee !== null) {
              setEFee(res.data.details.entry_fee);
            }
            if (res.data.photo !== null) {
              setPUrl(ImageUrl + res.data.path + res.data.details.photo);
            }
          }
        }
      })
    } else {
      setMName("");
      setMDob("");
      setMAge("");
      setSGender("");
      setMarital("");
      setHName("");
      setHDob("");
      setHAge("");
      setPhone("");
      setAPhone("");
      setAadno("");
      setMPlace("");
      setPFile("");
      setPUrl("");
      setSRel("");
      setSCaste("");
      setSubCas("");
      setMDetail("");
      setHDetail("");
      setPAddr("");
      setTAddr("");
      setOccu("");
      setIDaily("");
      setIMonth("");
      setIWDays("");
      setAnnInc("");
      setLIncome("");
      setPIncome("");
      setOIncome("");
      setOTotal("");
      setOHouse("No");
      setRHouse("No");
      setLHouse("No");
      setOAssets("No");
      setMGroup("");
      setEFee("");
      setHasActiveLoan(false);
    }

    religionlist().then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    })

    castelist().then((res) => {
      if (res.status === true) {
        setSCList(res.data);
      }
    })

    subcastelist().then((res) => {
      if (res.status === true) {
        setSubList(res.data);
      }
    })
    const temp = new FormData();
    temp.append("branch", localStorage.getItem("branch"));
    grouplist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].group_name
            })
          }
          setGList(arr);
        }
      }
    })


  }, [location.pathname]);

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const handleAadhar = (e) => {
    // Digits only, capped at 12 — Aadhaar is always a 12-digit number.
    const digits = e.target.value.replace(/\D/g, "").slice(0, 12);
    setAadno(digits);
    setAadhaarVerified(false);
    setAadhaarOtpSent(false);
  };

  // ----- KYC verification handlers (no member_id needed; verify before save) -----
  const onVerifyPan = async () => {
    if (!pan) return toast.error("Enter PAN number");
    setPanLoading(true);
    const res = await kycVerifyPan({ pan, name: mname });
    setPanLoading(false);
    if (res?.status === true) {
      setPanVerified(true);
      toast.success(res.message || "PAN verified");
    }
  };

  const onSendAadhaarOtp = async () => {
    if (!aadno || aadno.length < 12) return toast.error("Enter a valid 12-digit Aadhaar");
    setAadhaarLoading(true);
    const res = await kycAadhaarSendOtp({ aadhaar_no: aadno });
    setAadhaarLoading(false);
    if (res?.status === true) {
      setAadhaarRefId(res.data?.ref_id || "");
      setAadhaarOtpSent(true);
      toast.success(res.message || "OTP sent");
    }
  };

  const onVerifyAadhaarOtp = async () => {
    if (!aadhaarOtp) return toast.error("Enter OTP");
    setAadhaarLoading(true);
    const res = await kycAadhaarVerifyOtp({
      ref_id: aadhaarRefId,
      otp: aadhaarOtp,
      aadhaar_no: aadno,
    });
    setAadhaarLoading(false);
    if (res?.status === true) {
      setAadhaarVerified(true);
      setAadhaarOtpSent(false);
      setAadhaarOtp("");
      toast.success(res.message || "Aadhaar verified");
    }
  };

  const onVerifyBank = async () => {
    if (!bankAcc || !bankIfsc) return toast.error("Enter account number and IFSC");
    setBankLoading(true);
    const res = await kycVerifyBank({
      bank_account_no: bankAcc,
      bank_ifsc: bankIfsc,
      name: mname,
    });
    setBankLoading(false);
    if (res?.status === true) {
      setBankVerified(true);
      setBankName(res.data?.bank_name || "");
      toast.success(res.message || "Bank account verified");
    }
  };

  const handleAChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAPhone(e.target.value);
    }
  };

  const handleDaily = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setIDaily(e.target.value);
    }
  };
  const handleMonth = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setIMonth(e.target.value);
    }
  };
  const handleDays = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setIWDays(e.target.value);
    }
  };

  const handleAnnual = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAnnInc(e.target.value);
    }
  };

  const handleNIncome = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setLIncome(e.target.value);
    }
  };

  const handlePIncome = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPIncome(e.target.value);
    }
  };

  const handleOther = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setOIncome(e.target.value);
    }
  };

  const handleTotal = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setOTotal(e.target.value);
    }
  };

  const handleFee = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setEFee(e.target.value);
    }
  };



  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setPFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Photo should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photo size should be less than 5MB");
      }
    }
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/women.png");
    ev.target.onerror = null;
  }

  const [errmsg, setError] = useState("");
  const [successmsg, setSuccess] = useState(false);
  function submitmem(e) {
    e.preventDefault();
    setSuccess(true);
    // Aadhaar must be exactly 12 digits (uniqueness is enforced by the backend).
    if (aadno !== "" && aadno.length !== 12) {
      toast.error("Aadhaar number must be 12 digits");
      return;
    }
    var valid = "";
    if (mname !== "" && mdob !== "" && mage !== "" && sgender !== "" && marital !== ""  && phone !== "" && aadno.length === 12 && mplace !== "" && srel !== "" && scaste !== "" && subcas !== "") {
      setLoading(true);
      const temp = new FormData();
      temp.append("member_name", mname);
      temp.append("member_dob", mdob);
      temp.append("member_age", mage);
      temp.append("gender", sgender);
      temp.append("marital_status", marital);
      temp.append("husband_name", hname);
      temp.append("husband_dob", hdob);
      temp.append("husband_age", hage);
      temp.append("phone_no", phone);
      temp.append("alternate_no", aphone);
      temp.append("aadhar_no", aadno);
      // KYC verified data (verified via Cashfree before saving)
      temp.append("pan_no", pan);
      temp.append("pan_verified", panVerified ? 1 : 0);
      temp.append("aadhaar_verified", aadhaarVerified ? 1 : 0);
      temp.append("bank_account_no", bankAcc);
      temp.append("bank_ifsc", bankIfsc);
      temp.append("bank_name", bankName);
      temp.append("bank_verified", bankVerified ? 1 : 0);
      temp.append("native_place", mplace);
      temp.append("religion_id", srel);
      temp.append("caste_id", scaste);
      temp.append("subcaste_id", subcas);
      temp.append("member_detail", mdetail);
      temp.append("husband_detail", hdetail);
      temp.append("permanent_address", paddr);
      temp.append("temporary_address", taddr);
      temp.append("occupation", occu);
      temp.append("daily_income", idaily);
      temp.append("monthly_income", imonth);
      temp.append("working_days", iwdays);
      temp.append("annual_income", anninc);
      temp.append("nancei_income", lincome);
      temp.append("puncei_income", pincome);
      temp.append("other_income", oincome);
      temp.append("overall_total", ototal);
      temp.append("own_house", ohouse);
      temp.append("rent_house", rhouse);
      temp.append("lease_house", lhouse);
      temp.append("other_assets", oassets);
      temp.append("group_id", mgroup ? mgroup.value : "");
      // For individual members without group, send branch_id from localStorage
      if (!mgroup || !mgroup.value) {
        temp.append("branch_id", localStorage.getItem("branch"));
      }
      temp.append("photo", pfile);
      temp.append("entry_fee", efee || "0");

      if (urllink === "memberdetail" || urllink === "groupmemberdetail") {
        temp.append("id", id);
      }
      membercreate(temp).then((res) => {
        // Clear the loading overlay first: it hides the whole form, so if this
        // is skipped on rejection the error message below never becomes visible.
        setLoading(false);
        if (res && res.status === true) {
          toast.success(res.message);
          if (urllink === "groupmemberdetail") {
            navigate(`/group/groupdetail/${gid}`);
          } else {
            navigate("/member/allmembers");
          }
        } else {
          setError(res?.message || "Unable to save member. Please try again.");
        }
      })
    }
  }
  function backlist() {
    if (urllink === "groupmemberdetail") {
      navigate(`/group/groupdetail/${gid}`);
    } else {
      navigate("/member/allmembers");
    }
  }
  function handleGroup(e) {
    if (e !== null) {
      setMGroup(e);
    } else {
      setMGroup("");
    }
  }

  const [loading, setLoading] = useState(false);
  return (
    <div className="member-form">
      {/* Reserve two lines for every field label so a label that wraps (e.g.
          "Partner / Parents / Blood Relation Name") doesn't push its input lower
          than the other inputs in the same grid row. */}
      <style>{`
        .member-form .form-label {
          display: block;
          min-height: 2.8em;
          line-height: 1.3;
          margin-bottom: 4px;
        }
      `}</style>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "addmember" ? "Add Member" : "Member Detail"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Member</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "addmember" ? "Add Member" : "Member Detail"}
          </li>
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      {!loading && (
        <div className="content-body">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    {urllink === "addmember" ? "Add Member" : "Member Detail"}
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <label className="form-label">Photo</label>
                      <div className="avatar-upload">
                        <div className="avatar-preview">
                          <img
                            alt="avatar"
                            src={purl}
                            onError={(e) => errorphoto(e)}
                          />
                        </div>
                        <div className="change-btn mt-2 mb-lg-0 mb-3">
                          <input
                            type="file"
                            className="form-control"
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => photofile(e)}
                          />
                          {photoerror !== "" && (
                            <span className="text-danger">{photoerror}</span>
                          )}

                          <a
                            className="btn btn-secondary my-2"
                            onClick={() => {
                              setPUrl("");
                              setPFile("");
                            }}
                          >
                            Remove
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="row">
                        {(urllink === "memberdetail" ||
                          urllink === "groupmemberdetail") &&
                          uname !== "" && (
                            <>
                              <div className="col-xl-6 col-sm-6">
                                <div className="mb-3">
                                  <div className="username-field">
                                    Username : {uname}
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-6 col-sm-6">
                                <div className="mb-3">
                                  <div className="password-field">
                                    Password : {pass}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Member Name
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Member Name"
                              value={mname}
                              onChange={(e) => setMName(e.target.value)}
                              onKeyPress={LetterOnly}
                              onPaste={onPasteLetter}
                            />
                            {successmsg && mname === "" && (
                              <span className="text-danger">
                                Please Enter Member Name
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Member DOB
                              <span className="text-danger"> * (dd/mm/yyyy)</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={mdob}
                              onChange={(e) => {
                                setMDob(e.target.value);
                                setMAge(ageFromDob(e.target.value));
                              }}
                              placeholder="Enter Member DOB (dd/mm/yyyy)"
                            />
                            {successmsg && mdob === "" && (
                              <span className="text-danger">
                                Please Enter Member DOB
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Age
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Auto from DOB"
                              value={mage}
                              readOnly
                            />
                            {successmsg && mage === "" && (
                              <span className="text-danger">
                                Please Enter Member Age
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Gender <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={sgender}
                              onChange={(e) => setSGender(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Gender
                              </option>
                              <option value="Male">
                                Male
                              </option>
                              <option value="Female">
                                Female
                              </option>
                              <option value="Other">
                                Other
                              </option>
                            </select>
                            {successmsg && sgender === "" && (
                              <span className="text-danger">
                                Please Select Gender
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Marital Status <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={marital}
                              onChange={(e) => setMarital(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Marital Status
                              </option>
                              <option value="Single">
                                Single
                              </option>
                              <option value="Married" >
                                Married
                              </option>
                              <option value="Other">
                                Other
                              </option>
                            </select>
                            {successmsg && marital === "" && (
                              <span className="text-danger">
                                Please Select Marital Status
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Partner / Parents / Blood Relation Name
                              {/* <span className="text-danger"> *</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Partner / Parents / Blood Relation Name"
                              value={hname}
                              onChange={(e) => setHName(e.target.value)}
                              onKeyPress={LetterOnly}
                              onPaste={onPasteLetter}
                            />
                            {/* {successmsg && hname === "" && (
                              <span className="text-danger">
                                Please Enter Partner / Parents / Blood Relation Name
                              </span>
                            )} */}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Partner / Parents / Blood Relation DOB
                              <span className="text-danger"> (dd/mm/yyyy)</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={hdob}
                              onChange={(e) => {
                                setHDob(e.target.value);
                                setHAge(ageFromDob(e.target.value));
                              }}
                              placeholder="Enter Partner / Parents / Blood Relation DOB (dd/mm/yyyy)"
                            />
                            {/* {successmsg && hdob === "" && (
                              <span className="text-danger">
                                Please Enter Partner / Parents / Blood Relation DOB
                              </span>
                            )} */}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Partner / Parents / Blood Relation Age
                              {/* <span className="text-danger"> *</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Auto from DOB"
                              value={hage}
                              readOnly
                            />
                            {/* {successmsg && hage === "" && (
                              <span className="text-danger">
                                Please Enter Partner / Parents / Blood Relation Age
                              </span>
                            )} */}
                          </div>
                        </div>

                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Phone Number{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Phone Number"
                              value={phone}
                              maxLength={10}
                              onChange={handleChange}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />
                            {successmsg && phone === "" && (
                              <span className="text-danger">
                                Please Enter Phone Number
                              </span>
                            )}
                            {phone !== "" && phone.length < 10 && (
                              <span className="text-danger">
                                Phone Number should be 10 digits
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Aadhar Number
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Aadhar Number"
                              maxLength={12}
                              value={aadno}
                              onChange={handleAadhar}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />
                            {successmsg && aadno === "" && (
                              <span className="text-danger">
                                Please Enter Aadhar Number
                              </span>
                            )}
                            <div className="mt-2">
                              {!kycAllowed.aadhaar ? null : aadhaarVerified ? (
                                <span className="badge bg-success">
                                  <i className="fa fa-check-circle"></i> Aadhaar Verified
                                </span>
                              ) : aadhaarOtpSent ? (
                                <div className="d-flex align-items-center">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm me-2"
                                    style={{ maxWidth: "120px" }}
                                    placeholder="Enter OTP"
                                    maxLength={6}
                                    value={aadhaarOtp}
                                    onChange={(e) =>
                                      setAadhaarOtp(e.target.value.replace(/\D/g, ""))
                                    }
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    disabled={aadhaarLoading}
                                    onClick={onVerifyAadhaarOtp}
                                  >
                                    {aadhaarLoading ? "..." : "Verify OTP"}
                                  </button>
                                </div>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  disabled={aadhaarLoading}
                                  onClick={onSendAadhaarOtp}
                                >
                                  {aadhaarLoading ? "Sending..." : "Verify Aadhaar (Send OTP)"}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* PAN Verification */}
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">PAN Number</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter PAN Number"
                              maxLength={10}
                              value={pan}
                              disabled={panVerified}
                              onChange={(e) => {
                                setPan(e.target.value.toUpperCase());
                                setPanVerified(false);
                              }}
                            />
                            <div className="mt-2">
                              {!kycAllowed.pan ? null : panVerified ? (
                                <span className="badge bg-success">
                                  <i className="fa fa-check-circle"></i> PAN Verified
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  disabled={panLoading}
                                  onClick={onVerifyPan}
                                >
                                  {panLoading ? "Verifying..." : "Verify PAN"}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Bank Verification */}
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Bank Account Number</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Account Number"
                              value={bankAcc}
                              disabled={bankVerified}
                              onChange={(e) => {
                                setBankAcc(e.target.value.replace(/\D/g, ""));
                                setBankVerified(false);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">IFSC Code</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="IFSC"
                              maxLength={11}
                              value={bankIfsc}
                              disabled={bankVerified}
                              onChange={(e) => {
                                setBankIfsc(e.target.value.toUpperCase());
                                setBankVerified(false);
                              }}
                            />
                            <div className="mt-2">
                              {!kycAllowed.bank ? null : bankVerified ? (
                                <span className="badge bg-success">
                                  <i className="fa fa-check-circle"></i> Bank Verified
                                  {bankName ? ` (${bankName})` : ""}
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  disabled={bankLoading}
                                  onClick={onVerifyBank}
                                >
                                  {bankLoading ? "Verifying..." : "Verify Bank"}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Native Place
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Native Place"
                              value={mplace}
                              onChange={(e) => setMPlace(e.target.value)}
                            />
                            {successmsg && mplace === "" && (
                              <span className="text-danger">
                                Please Enter Native Place
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Religion <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={srel}
                              onChange={(e) => setSRel(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Religion
                              </option>
                              {rlist.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {item.religion_name}
                                  </option>
                                );
                              })}
                            </select>
                            {successmsg && srel === "" && (
                              <span className="text-danger">
                                Please Select Religion
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Caste <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={scaste}
                              onChange={(e) => setSCaste(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Caste
                              </option>
                              {sclist.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {item.caste_name}
                                  </option>
                                );
                              })}
                            </select>
                            {successmsg && scaste === "" && (
                              <span className="text-danger">
                                Please Select Caste
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Sub-Caste <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={subcas}
                              onChange={(e) => setSubCas(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Sub-Caste
                              </option>
                              {sublist.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {item.subcaste_name}
                                  </option>
                                );
                              })}
                            </select>
                            {successmsg && subcas === "" && (
                              <span className="text-danger">
                                Please Select Sub-Caste
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Alternate Number{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Alternate Number"
                              value={aphone}
                              maxLength={10}
                              onChange={handleAChange}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />

                            {aphone !== "" && aphone.length < 10 && (
                              <span className="text-danger">
                                Alternate Number should be 10 digits
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Member Detail</label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Member Detail"
                              value={mdetail}
                              onChange={(e) => setMDetail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Partner / Parents / Blood Relation Detail</label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Partner / Parents / Blood Relation Detail"
                              value={hdetail}
                              onChange={(e) => setHDetail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Permanent Address
                            </label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Permanent Address"
                              value={paddr}
                              onChange={(e) => setPAddr(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Temporary Address
                            </label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Temporary Address"
                              value={taddr}
                              onChange={(e) => setTAddr(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 mt-2">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Income Details
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Occupation</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Occupation"
                          value={occu}
                          onChange={(e) => setOccu(e.target.value)}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Daily </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Daily income"
                          maxLength={10}
                          value={idaily}
                          onChange={handleDaily}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Monthly</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Monthly Income"
                          maxLength={10}
                          value={imonth}
                          onChange={handleMonth}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Working Days</label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={10}
                          placeholder="Enter Working Days"
                          value={iwdays}
                          onChange={handleDays}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Annual Income</label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={10}
                          placeholder="Enter Annual Income"
                          value={anninc}
                          onChange={handleAnnual}
                        />

                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Land income
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Nansei Income</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Nansei Income"
                          value={lincome}
                          onChange={handleNIncome}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Punsei Income</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Punsei Income"
                          value={pincome}
                          onChange={handlePIncome}
                          maxLength={10}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Other Income</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Other Income"
                          value={oincome}
                          onChange={handleOther}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Overall Total</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Total Income"
                          value={ototal}
                          onChange={handleTotal}
                        />

                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Asset Details
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Own House
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={ohouse}
                          onChange={(e) => setOHouse(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Own House
                          </option>

                          <option value="Yes">Yes</option>
                          <option value="No">No</option>

                        </select>
                        {successmsg && ohouse === "" && (
                          <span className="text-danger">
                            Please Select Own House
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Rent House
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={rhouse}
                          onChange={(e) => setRHouse(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Rent House
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {successmsg && rhouse === "" && (
                          <span className="text-danger">
                            Please Select Rent House
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {" "}
                          Lease House
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={lhouse}
                          onChange={(e) => setLHouse(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Lease House
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {successmsg && lhouse === "" && (
                          <span className="text-danger">
                            Please Select Lease House
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Other Assets</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Other Assets"
                          value={oassets}
                          onChange={(e) => setOAssets(e.target.value)}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {groupLoansAllowed && (
          <div className="row mt-2">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Group Detail
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Group (Optional for Individual Loans)
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Group (Optional)"
                          value={mgroup}
                          options={glist}
                          onChange={handleGroup}
                          isSearchable={true}
                          isClearable
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                          // Editable while adding, or while editing a member who
                          // has no loan in progress; locked once a loan is live.
                          isDisabled={hasActiveLoan}
                        />
                        {hasActiveLoan && (
                          <small className="text-danger">
                            Group can't be changed while a loan is in progress.
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Entry Fee (Optional)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Entry Fee (Optional)"
                          maxLength={10}
                          value={efee}
                          onChange={handleFee}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}
          {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
          <div className="res-right mt-2 me-4">
            <button className="btn btn-success me-2" onClick={submitmem}>
              Submit
            </button>
            {urllink === "memberdetail" || urllink === "groupmemberdetail" &&
              <button className="btn btn-secondary" onClick={backlist}>Back</button>
            }
          </div>
        </div>
      )}
    </div>
  );
}
